module.exports = __webpack_public_path__ + "media/images/icons/flags/QA-e3e68ad9970cbd7ae06c7cf90c2fa392.svg";